import * as React from 'react'
import { Section, ListContainer } from '../atoms'
import { ReducerProps } from '../reducer'
import { getSelectionPanelStyles as getStyles } from './styles'
import { useFilteredColumns } from './useFilteredColumns'
import { Searchbox } from './Searchbox'
import { SelectionListItem } from './SelectionListItem'
import { SelectButtons } from './SelectButtons'

import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

export const SelectionPanel: React.FC<ReducerProps> = (props) => {
  const {
    state: { columns },
  } = props
  const theme = useTheme()
  const { label } = getStyles(theme)

  const { filteredColumns, ...filterActions } = useFilteredColumns(columns)

  return (
    <Section>
      <Typography sx={label}>
        Select the columns you would like to display
      </Typography>

      <Searchbox {...filterActions} />

      <Typography sx={label}>Available Columns</Typography>

      <SelectButtons {...props} />

      <ListContainer>
        {filteredColumns.map((col) => (
          <SelectionListItem key={col.field} column={col} {...props} />
        ))}
      </ListContainer>
    </Section>
  )
}
